import { Component, OnInit,Input ,Output,OnDestroy,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-payer-group-row',
  templateUrl: './payer-group-row.component.html',
  styleUrls: ['./payer-group-row.component.scss']
})
export class PayerGroupRowComponent implements OnInit,OnDestroy {
  show : boolean = false;
  @Input() group : any;
  @Input("count-label") countLabel : any;
  @Input() index : any;
  @Input("can-delete") canDelete : any;
  @Output("on-delete") deleteEvent = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.deleteEvent.unsubscribe();
    this.deleteEvent = null;
  }

  delete(){
    this.deleteEvent.emit(this.index);
  }

  toggleShow(){
    this.show = !this.show;
  }

}
